
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokumen/[id]",
      function () {
        return require("private-next-pages/dokumen/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokumen/[id]"])
      });
    }
  